import { createAction } from '@/utils/actionCreator';
import ActionTypes from './actionTypes';

export const getTeams = createAction(ActionTypes.TEAMS_GET, 'params');
